import HyperLink from './HyperLink';
import HyperlinkNewTab from './HyperlinkNewTab';

export { HyperLink, HyperlinkNewTab };
